import {Axios as http} from '../axios/axios'

export const getCouponList = (data) => {
  return http({
    url: '/adminapi/getCouponList',
    method: 'POST',
    data,
  })
}

export const addCoupon = (data) => {
  return http({
    url: '/adminapi/addCoupon',
    method: 'POST',
    data,
  })
}

export const sendCoupons = (url, data) => {
  return http({
    url: `/adminapi/${url}`,
    method: 'POST',
    data,
  })
}

export const couponHistory = (data) => {
  return http({
    url: '/adminapi/getCouponUsageLog',
    method: 'POST',
    data,
  })
}

export const editCoupon = (data) => {
  return http({
    url: '/adminapi/editCoupon',
    method: 'POST',
    data,
  })
}

export const getCouponRecipients = (data) => {
  return http({
    url: '/adminapi/getCouponRecipients',
    method: 'POST',
    data,
  })
}

export const getCouponDetail = (data) => {
  return http({
    url: '/adminapi/getCouponDetail',
    method: 'POST',
    data,
  })
}